import {
  taskLibraryInfoFragment,
  taskInfoFragment,
} from './fragments/taskInfoFragment';

export const query = `query taskById($taskId: String!){
  publicTask(taskId:$taskId){
    ${taskInfoFragment}
    publicTaskLibrary {
      ${taskLibraryInfoFragment}
    }
  }
}`;
